module.exports = __webpack_public_path__ + "img/chatbox.a0b9cf77.svg";